export default "__VITE_ASSET__YFQQi0J8__"